import { ActionTree, Action } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { StepSequencerState } from '@/store/types/step-sequencer.state';

export const actions: ActionTree<StepSequencerState, RootState> = {
    setChords({ commit, state }) {
        const chords: any[] = [];
        //Inicialitzem l'array
        for (let i = 0; i < 4; i++) {
            chords[i] = [];
        }
        // I li assignem els valors que toca
        for (const col in state.selected) {
            for (const tone in state.selected[col]) {
                if (state.selected[col][tone]) {
                    chords[tone].push(col);
                }
            }
        }
        commit('setChords', chords);
    },
    updateChord({ commit, state }) {
        commit('setCurrentChord', state.chords[state.currentChordN]);
    },
    nextChord({ commit, state, dispatch }) {
        commit('setCurrentChordN', (state.currentChordN + 1) % 4);
        dispatch('setChords');
        dispatch('updateChord');
    },
}